
/// <reference path="../../../../rcwebmodels/reeferformatter.cs.d.ts" />
/// <reference path="../../../../rcwebmodels/ChassisAssetsMgmtModel.cs.d.ts" />
import { fetch, addTask } from 'domain-task';
import { Action, Reducer, ActionCreator } from 'redux';
import { AppThunkAction } from './';
import { RCUtils } from './../RCUtils';
import { PopupWindow } from '../components/sharedcomponents/PopupWindow';
var Config: any = require('../Config.json');

// -----------------
// STATE - This defines the type of data maintained in the Redux store.

export interface ChassisSearchState {
    isLoading: boolean;
    /* WI 26566 changes start */
    allAssetStatus: any[];
    gridType: any;
    gensetStatus: any[];
    reeferStatus: any[];
    dryStatus: any[];
    /* WI 26566 changes end */
    searchFilters: server.ReeferSearchFilters;
    chassisStatus: server.ChassisStatusData[];
    columnDefs: any[];
}

// -----------------
// ACTIONS - These are serializable (hence replayable) descriptions of state transitions.
// They do not themselves have any side-effects; they just describe something that is going to happen.

interface RequestChassisSearchAction {
    type: 'REQUEST_CHASSIS_ADVANCE_SEARCH';
    searchFilters: server.ReeferSearchFilters;
    colDefs: any[];
}

interface ReceiveChassisSearchAction {
    type: 'RECEIVE_CHASSIS_ADVANCE_SEARCH_DETAILS';
    searchFilters: server.ReeferSearchFilters;
    /* WI 26566 changes start */
    allAssetStatusData: any[];
    gridType: any;
    gensetStatusData: any[];
    reeferStatusData: any[];
    dryStatusData: any[];
    /* WI 26566 changes end */
    chassisStatusData: server.ChassisStatusData[];
    colDefs: any[];
}
/* WI 26566 changes start */
interface ReceiveAllAssetTypeSearchAction {
    type: 'RECEIVE_AllAssetType_ADVANCE_SEARCH';
    searchFilters: server.ReeferSearchFilters;
    allAssetStatusData: any[];
    gridType: any;
    gensetStatusData: any[];
    reeferStatusData: any[];
    dryStatusData: any[];
    chassisStatusData: server.ChassisStatusData[];
    colDefs: any[];
}
/* WI 26566 changes end */


// Declare a 'discriminated union' type. This guarantees that all references to 'type' properties contain one of the
// declared type strings (and not any other arbitrary string).
type KnownAction = RequestChassisSearchAction | ReceiveChassisSearchAction | ReceiveAllAssetTypeSearchAction;

// ----------------
// ACTION CREATORS - These are functions exposed to UI components that will trigger a state transition.
// They don't directly mutate state, but they can have external side-effects (such as loading data).

export const actionCreators = {
    requestChassisAdvanceSearch: (searchFilters: server.ReeferSearchFilters, reeferCols: any[]): AppThunkAction<KnownAction> => (dispatch, getState) => {
        // Only load data if it's something we don't already have (and are not already loading)
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/Asset/ChassisStatusDataSP', { method: 'POST', body: JSON.stringify(searchFilters), headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } })
        let fetchTask = fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<server.ChassisStatusData[]>)
            .then(data => {
                if (data.length > 0) {
                    if (data[0].ErrorMessage != null && data[0].ErrorMessage != undefined && data[0].ErrorMessage != "") {
                        if (data[0].ErrorMessage == "Execution Timeout Expired.  The timeout period elapsed prior to completion of the operation or the server is not responding.") {
                            PopupWindow.showErrorMessage("Refine Search!", "Server is busy. Please try after sometime.");
                            dispatch({ type: 'RECEIVE_AllAssetType_ADVANCE_SEARCH', searchFilters: searchFilters, gridType: 'chassis', allAssetStatusData: [], chassisStatusData: [], reeferStatusData: [], dryStatusData: [], gensetStatusData:[], colDefs: reeferCols });
                        }
                        else {
                            PopupWindow.showErrorMessage("Refine Search!", "Your search returns too many results. Please refine your search.");
                            dispatch({ type: 'RECEIVE_AllAssetType_ADVANCE_SEARCH', searchFilters: searchFilters, gridType: 'chassis', allAssetStatusData: [], chassisStatusData: [], reeferStatusData: [], dryStatusData: [], gensetStatusData: [], colDefs: reeferCols });
                        }
                    }
                    else {
                        dispatch({ type: 'RECEIVE_AllAssetType_ADVANCE_SEARCH', searchFilters: searchFilters, gridType: 'chassis', allAssetStatusData: data, chassisStatusData: data, reeferStatusData: [], dryStatusData: [], gensetStatusData: [], colDefs: reeferCols });
                    }
                }
                else
                    dispatch({ type: 'RECEIVE_AllAssetType_ADVANCE_SEARCH', searchFilters: searchFilters, gridType: 'chassis', allAssetStatusData: [], chassisStatusData: [], reeferStatusData: [], dryStatusData: [], gensetStatusData: [], colDefs: reeferCols });
            });

        addTask(fetchTask); // Ensure server-side prerendering waits for this to complete
        dispatch({ type: 'REQUEST_CHASSIS_ADVANCE_SEARCH', searchFilters: searchFilters, colDefs: reeferCols });
    }
};

// ----------------
// REDUCER - For a given state and action, returns the new state. To support time travel, this must not mutate the old state.
//const emptyAdvanceSearchFilter = { CustomerTypeCode: null, CustomerID: null, AssetType: null, AssetNumber: null, ServerFence: null, DeviceFence: null, Region: null, City: null, State: null,ZipCode: null, Country: null, Geofence: null, POI: null, Oem: null, ReportingInterval: null, GeofenceInside: null}
const emptySearchFilter = {
    SelectedOem: null, SelectedCountry: null, SelectedReefer: null, SelectedGeofence: null, SelectedInterval: null, SelectedGeofenceInside: null, SelectedVesselCode: null, StatusFilters: [], AllReefers: null, CustomAttributeFilters: null, SelectedAssetTypes: null, SelectedAssetStates: null, SelectedBookingNumber: null, SelectedVesselCD: null, SelectedCall: null,
    SelectedVoyage: null, SelectedCargoCareProfiles: null, SelectedPod: null, SelectedPol: null, SelectedCTProfileIds: [] //WI-26881
}
const unloadedState: ChassisSearchState = { isLoading: false, gridType: '', allAssetStatus: [], reeferStatus: [], dryStatus: [], gensetStatus:[], searchFilters: emptySearchFilter, chassisStatus: [], columnDefs: [] };

export const reducer: Reducer<ChassisSearchState> = (state: ChassisSearchState, incomingAction: Action) => {
    const action = incomingAction as KnownAction;
    switch (action.type) {
        case 'REQUEST_CHASSIS_ADVANCE_SEARCH':
            return {
                searchFilters: action.searchFilters,
                gridType: state.gridType,
                /* WI 26566 changes start */
                allAssetStatus: state.allAssetStatus,
                reeferStatus: state.reeferStatus,
                dryStatus: state.dryStatus,
                gensetStatus: state.gensetStatus,
                /* WI 26566 changes end */
                chassisStatus: state.chassisStatus,
                isLoading: true,
                columnDefs: state.columnDefs
            };


        case 'RECEIVE_CHASSIS_ADVANCE_SEARCH_DETAILS':
            // Only accept the incoming data if it matches the most recent request. This ensures we correctly
            // handle out-of-order responses.
            if (action.searchFilters === state.searchFilters) {
                return {
                    searchFilters: action.searchFilters,
                    gridType: action.gridType,
                    /* WI 26566 changes start */
                    allAssetStatus: action.allAssetStatusData,
                    reeferStatus: action.reeferStatusData,
                    dryStatus: action.dryStatusData,
                    gensetStatus: action.gensetStatusData,
                    /* WI 26566 changes end */
                    chassisStatus: action.chassisStatusData,
                    isLoading: false,
                    columnDefs: action.colDefs
                };
            }
        /* WI 26566 changes start */
        case 'RECEIVE_AllAssetType_ADVANCE_SEARCH':
            // Only accept the incoming data if it matches the most recent request. This ensures we correctly
            // handle out-of-order responses.
            if (action.searchFilters === state.searchFilters) {
                return {
                    searchFilters: action.searchFilters,
                    gridType: action.gridType,
                    allAssetStatus: action.allAssetStatusData,
                    reeferStatus: action.reeferStatusData,
                    dryStatus: action.dryStatusData,
                    gensetStatus: action.gensetStatusData,
                    chassisStatus: action.chassisStatusData,
                    isLoading: false,
                    columnDefs: action.colDefs
                };
            }
            /* WI 26566 changes end */
            break;

        default:
            // The following line guarantees that every action in the KnownAction union has been covered by a case above
            const exhaustiveCheck: never = action;
    }

    return state || unloadedState;
};
